import { z } from 'zod/v4';
import { CAPA_ACTION_PRIORITY } from '../../constants.js';

const capaActionPriorityValues = Object.values(CAPA_ACTION_PRIORITY) as [
  string,
  ...string[],
];

export const BulkUpdateSeverityItemSchema = z.object({
  id: z.string().min(1),
  severity: z.enum(capaActionPriorityValues),
});

export const BulkUpdateSeverityRequestSchema = z
  .array(BulkUpdateSeverityItemSchema)
  .min(1);

export type BulkUpdateSeverityRequest = z.infer<
  typeof BulkUpdateSeverityRequestSchema
>;

export const BulkUpdateSeverityResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateSeverityResponse = z.infer<
  typeof BulkUpdateSeverityResponseSchema
>;
